import styled from 'styled-components';

const StyledPartnershipRow = styled.div`
  position: relative;
  margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  .paragraph--col-wrap{
    padding: 0 0 24px;
  }
  .paragraph--col-wrap p{
    margin-bottom: 24px;
  }
  .swiper-slide{
    width: auto;
    height: 128px;
    display: flex;
    align-items: center;
    margin-right: 80px;
    margin-top: ${props => props.theme.components_spacing_desk.large}px;
  }
  .swiper-slide img{
    max-height: 78px;
    margin: 0 auto;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
  @media screen and (max-width: 1023px){
    
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    .swiper-slide{
      margin-top: ${props => props.theme.components_spacing_tablet.large}px;
    }
  }
  @media screen and (max-width: 767px){
    
    padding-right: 24px;
    padding-left: 24px;
    margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;

    .swiper-slide{
      margin-top: ${props => props.theme.components_spacing_mobile.large}px;
    }

  }
`;

export {
  StyledPartnershipRow,
};

